import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GatewayCard = ({ gateway, onToggleStatus, onConfigure }) => {
  const getGatewayIcon = (name) => {
    const icons = {
      'Stripe': 'CreditCard',
      'PayPal': 'Wallet',
      'Square': 'Square',
      'Razorpay': 'Smartphone'
    };
    return icons?.[name] || 'DollarSign';
  };

  const getGatewayColor = (name) => {
    const colors = {
      'Stripe': 'bg-blue-500',
      'PayPal': 'bg-indigo-500',
      'Square': 'bg-gray-700',
      'Razorpay': 'bg-purple-500'
    };
    return colors?.[name] || 'bg-gray-500';
  };

  const isActive = gateway?.status === 'active';

  return (
    <div className="bg-card border border-border rounded-xl p-5 md:p-6 shadow-sm hover:shadow-md transition-smooth">
      {/* Header with Icon and Status */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div
            className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${getGatewayColor(
              gateway?.name
            )} flex items-center justify-center flex-shrink-0`}
          >
            <Icon
              name={getGatewayIcon(gateway?.name)}
              size={24}
              color="white"
            />
          </div>
          <div>
            <h3 className="text-lg md:text-xl font-semibold text-foreground">
              {gateway?.name}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground mt-0.5">
              {gateway?.type}
            </p>
          </div>
        </div>
        <span
          className={`px-3 py-1 rounded-full text-xs font-medium ${
            isActive
              ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
          }`}
        >
          {isActive ? 'Active' : 'Inactive'}
        </span>
      </div>

      {/* Transaction Count */}
      <div className="mb-5">
        <p className="text-xs md:text-sm text-muted-foreground mb-1">
          TRANSACTIONS
        </p>
        <p className="text-2xl md:text-3xl font-semibold text-foreground">
          {gateway?.transactionCount?.toLocaleString()}
        </p>
      </div>

      {/* Action Button */}
      <Button
        variant="outline"
        fullWidth
        onClick={() => onConfigure(gateway)}
        className="mb-3"
      >
        Configure
      </Button>

      {/* Toggle Status Button */}
      <Button
        variant={isActive ? 'danger' : 'success'}
        fullWidth
        onClick={() => onToggleStatus(gateway?.id, gateway?.status)}
      >
        {isActive ? 'Deactivate' : 'Activate'}
      </Button>
    </div>
  );
};

export default GatewayCard;